import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'name',
      type: 'input',
      label: '名称',
      clearable: true,
      placeholder: '请输入名称'
    },
    {
      field: 'cstatus',
      type: 'select',
      label: '状态',
      filterable: true,
      clearable: true,
      placeholder: '请选择状态',
      options: [
        {title: '正常', value: 0},
        {title: '认证到期', value: 1},
        {title: '封号', value: 2}
      ]
    },
    {
      field: 'manager',
      type: 'input',
      label: '管理员',
      clearable: true,
      placeholder: '请输入管理员'
    },
    {
      field: 'originalId',
      type: 'input',
      label: '原始ID',
      clearable: true,
      placeholder: '请输入原始ID'
    },
    {
      field: 'remark',
      type: 'input',
      label: '备注',
      clearable: true,
      placeholder: '请输入关键词'
    }
  ]
}
